import ModelFactory from "./factory/ModelFactory";
import {parsePropertyName, getObjectClassName} from "./factory/utils";

export default class BaseModel {
    /**
     * @param collection
     * @param element
     */
    addCollectionElement(collection, element) {
        collection.push(element);
    }

    /**
     * @param collection
     * @param element
     */
    removeCollectionElement(collection, element) {
        const index = collection.indexOf(element);

        if (index !== -1) {
            collection.splice(index, 1);
        }
    }

    /**
     * @return {BaseModel}
     */
    static create(data = null) {
        const factory = new ModelFactory();
        const modelClassName = getObjectClassName(this);

        return factory.createModel(modelClassName, data);
    }

    /**
     * @return {Object}
     */
    serialize() {
        let serializedObject = {};
        const properties = Object.getOwnPropertyNames(this);

        properties.map(property => {
            const parsedProperty = parsePropertyName(property);
            let propertyValue = this[parsedProperty];

            if (propertyValue instanceof BaseModel) {
                propertyValue = propertyValue.serialize();
            }
            else if (propertyValue instanceof Array) {
                let collection = [];

                propertyValue.map(value => {
                    if (value instanceof BaseModel) {
                        value = value.serialize();
                    }

                    collection.push(value);
                });

                propertyValue = collection;
            }

            serializedObject[parsedProperty] = propertyValue;
        });

        return serializedObject;
    }
}